<ion-item-divider>
	<ion-label class="schedule">
		<h3>{{ getDisplay() }}</h3>
	</ion-label>
	<ion-label class="pause" [ngStyle]="{ 'height.px' : getHeight() }">
		&nbsp;
	</ion-label>
</ion-item-divider>